import { KitIcon } from '../_components/kit-icon';
import { IconHOC } from '../_components/icon-hoc';
var PATH = [
    'M7.88901 7.18197L4.70703 3.99999L7.88901 0.818008L7.18191 0.110901L3.99993 3.29288L0.817947 0.110901L0.11084 0.818008L3.29282 3.99999L0.11084 7.18197L0.817947 7.88908L3.99993 4.7071L7.18191 7.88908L7.88901 7.18197Z',
];
export var NavigationDeleteCircleIcon = IconHOC({
    paths: PATH,
    viewBox: '-4 -4 16 16',
})(KitIcon);
